<template>
  <div class="spinner" :style="{ fontSize: `${size}px` }"></div>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    size: {
      type: Number,
      default: 100,
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/variables.chi.scss";

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -0.5em;
  border-top: 0.1em solid rgba(255, 255, 255, 0.25);
  border-right: 0.1em solid rgba(255, 255, 255, 0.25);
  border-bottom: 0.1em solid rgba(255, 255, 255, 0.25);
  border-left: 0.1em solid rgba($primary, 0.75);
  transform: translateZ(0);
  animation: spin 1s infinite linear;
  flex: 0;

  &,
  &:after {
    border-radius: 50%;
    width: 1em;
    height: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/utility/Spinner.vue